/**
 * Vertaalt backend/API foutmeldingen naar begrijpelijke Nederlandse tekst.
 * Gebruik: getUserErrorMessage(error, 'standaard bericht')
 */

const KNOWN_ERRORS = {
  // Auth
  'invalid credentials': 'Uw e-mailadres of wachtwoord is onjuist.',
  'unauthorized': 'U bent niet meer ingelogd. Log opnieuw in om verder te gaan.',
  'token expired': 'Uw sessie is verlopen. Log opnieuw in.',
  'not authenticated': 'U bent niet ingelogd. Log eerst in om door te gaan.',
  'forbidden': 'U heeft geen toegang tot deze functie.',
  'access denied': 'U heeft geen toegang tot deze functie.',
  // Validation
  'not found': 'Het opgevraagde item kon niet worden gevonden.',
  'already exists': 'Dit item bestaat al. Kies een andere naam of waarde.',
  'duplicate': 'Er bestaat al een item met dezelfde gegevens.',
  'required': 'Niet alle verplichte velden zijn ingevuld.',
  'validation error': 'De ingevoerde gegevens zijn ongeldig. Controleer uw invoer.',
  // Rate limits
  'rate limit': 'U heeft te veel verzoeken gedaan. Wacht even en probeer het opnieuw.',
  'too many requests': 'U heeft te veel verzoeken gedaan. Wacht even en probeer het opnieuw.',
  // Server
  'internal server error': 'Er is een onverwachte fout opgetreden. Probeer het later opnieuw.',
  'service unavailable': 'De service is tijdelijk niet beschikbaar. Probeer het later opnieuw.',
  'bad gateway': 'Er is een verbindingsprobleem. Probeer het later opnieuw.',
  'timeout': 'Het verzoek duurde te lang. Controleer uw internetverbinding en probeer het opnieuw.',
  'network error': 'Er is een verbindingsprobleem. Controleer uw internetverbinding.',
};

export const getUserErrorMessage = (error, fallback = 'Er ging iets mis. Probeer het later opnieuw.') => {
  // Get the raw error detail from the API
  const detail = error?.response?.data?.detail || error?.message || '';
  
  if (!detail || typeof detail !== 'string') return fallback;
  
  const lower = detail.toLowerCase();
  
  // Check against known error patterns
  for (const [pattern, message] of Object.entries(KNOWN_ERRORS)) {
    if (lower.includes(pattern)) return message;
  }
  
  // If the message is already in Dutch (contains Dutch-specific chars/words), pass through
  if (/mislukt|fout|ongeldig|verplicht|bestaat|gevonden|probeer|controleer|ingevuld|toegang/i.test(detail)) {
    return detail;
  }
  
  // If message looks like a technical English error, use the fallback
  if (/^[a-zA-Z\s:_\-\d.]+$/.test(detail) && detail.length < 200) {
    return fallback;
  }
  
  return fallback;
};
